import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, Injector, ChangeDetectorRef, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { of } from 'rxjs';

import { CatalogEntryQuestion } from '@apps/its2/domain/models';
import { QuestionListItem } from '@apps/its2/domain/models/catalog-entry-question';
import { SelectOption2 } from '@ui/components/form/common/select-option';

import { InputCombobox2Component } from '../../input-combobox2/input-combobox2.component';

@Component({
    selector: 'aa-input-its2-list',
    templateUrl: '../../input-combobox2/input-combobox2.component.html',
    styleUrls: [
        '../../input.component.scss',
        '../../input-combobox/input-combobox.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputIts2ListComponent,
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputIts2ListComponent extends InputCombobox2Component implements OnChanges
{
    @Input() question: CatalogEntryQuestion;

    constructor (
        injector: Injector,
        changeDetectorRef: ChangeDetectorRef
    )
    {
        super(injector, changeDetectorRef);
    }

    ngOnChanges (changes: SimpleChanges): void
    {
        if (changes.question && changes.question.currentValue)
        {
            this.items = of(this.question.definition.list.string
                .map((qli: QuestionListItem) =>
                    new SelectOption2<string>(qli.FR, qli.FR)
                )
            );
        }
    }
}
